import {constructFilter} from './constructFilter';
import {TFunction} from 'i18next';
import {ParkingLotDto} from '@lib/infrastructure';

export const SECTION_ID_PARKING_LOTS = 'SECTION_ID_PARKING_LOTS';

export const constructParkingLotFilter = <TEntity extends {parkingLotId: string}>(
  parkingLots: ParkingLotDto[],
  t: TFunction,
) =>
  constructFilter({
    sectionId: SECTION_ID_PARKING_LOTS,
    sectionTitle: t('parking:ParkingLot'),
    type: 'singleOptional',
    data: parkingLots.map(({id, name}) => ({id, label: name})),
    predicate: (filter, entity: TEntity) => entity.parkingLotId === filter.id,
    defaultFilterOptions: undefined,
  });
